import { render, staticRenderFns } from "./costs.vue?vue&type=template&id=330c6bfa&scoped=true&"
import script from "./costs.vue?vue&type=script&lang=js&"
export * from "./costs.vue?vue&type=script&lang=js&"
import style0 from "./costs.vue?vue&type=style&index=0&id=330c6bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c6bfa",
  null
  
)

export default component.exports